import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";

// get the user profile image/avatar
const getProfileImage = async (token) => {

  let status = STATUSES.SUCCESS;

  //console.log("getProfileImage()");
  const url = "/api/userProfile/getImage";
  const res = await http.post(url, {}, {
    responseType: "blob",
    headers: {
      "Authorization": token
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("getProfileImage()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// get the user profile image/avatar
const saveProfileImage = async (token, avatarData) => {

  let status = STATUSES.SUCCESS;

  console.log("saveProfileImage()");
  const url = "/api/userProfile/saveImage";
  const res = await http.post(url, avatarData, {
    headers: {
      "Authorization": token,
      "Content-Type": "multipart/form-data"
    }
  }).then(res => {

    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    //console.log("saveProfileImage()", error);
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};



export { getProfileImage, saveProfileImage } 